import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * Hero Component
 * 
 * Main hero section for landing page.
 * Features:
 * - Large title with gradient text effects
 * - Subtitle
 * - Call-to-action button
 * 
 * Exact styles from landing.css:
 * - Hero title: 4.5rem (72px), line-height: 1.1, letter-spacing: -0.02em
 * - Subtitle: 1.25rem (20px), max-width: 600px
 * - Padding: 6rem 1rem (96px 16px)
 * - Text alignment: center
 * - Max width: 800px
 */
const Hero = () => {
  const { currentUser } = useAuth();
  return (
    <section className="hero text-center py-12 md:py-20 lg:py-24 px-4 md:px-8 max-w-hero mx-auto relative z-content">
      {/* Hero Title - MOBILE: Better scaling */}
      <h1 className="hero-title text-4xl xs:text-5xl sm:text-6xl md:text-7xl lg:text-hero-title leading-[1.1] font-medium mb-4 md:mb-6 tracking-[-0.02em]">
        <span className="text-gradient-smart">Smart</span>{' '}
        <span className="text-gradient-legal">Legal</span>{' '}
        <span>and</span>{' '}
        <span className="text-gradient-financial">Financial</span>{' '}
        <span className="text-text-primary drop-shadow-hero-text">
          Assistant
        </span>
      </h1>

      {/* Subtitle */}
      <p className="hero-subtitle text-base md:text-lg lg:text-hero-subtitle text-text-secondary max-w-hero-subtitle mx-auto mb-6 md:mb-8 lg:mb-10 font-normal">
        Simplify legal contracts, automate tax compliance, and get instant AI-powered insights—all in one place.
      </p>

      {/* CTA Button - MOBILE: 48px minimum touch target */}
      {!currentUser && (
        <Link
          to="/register"
          className="btn-primary bg-btn-bg text-btn-text border border-white/20 px-4 md:px-5 lg:px-6 py-3 md:py-3 rounded-btn-primary text-nav-btn font-medium cursor-pointer transition-all duration-300 shadow-btn-primary hover:shadow-btn-primary-hover hover:-translate-y-0.5 inline-block no-underline backdrop-blur-btn-primary min-h-[48px] flex items-center justify-center touch-manipulation active:scale-[0.98]"
        >
          Get Started Free
        </Link>
      )}
    </section>
  );
};

export default Hero;

